import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getTwitchOAuth } from 'src/store/auth';

import { CustomButton } from 'src/components';

import './hero.scss';

export const Hero = () => {
  const { t } = useTranslation('hero');

  const dispatch = useDispatch();

  const onClickConnect = useCallback(() => {
    dispatch(getTwitchOAuth());
  }, [dispatch]);

  return (
    <section className="landing__hero">
      <div className="landing__hero-content">
        <h1 className="landing__hero-title">{t('title')}</h1>
        <p className="landing__hero-subtitle">{t('description')}</p>
        <div className="landing__hero-cta">
          <CustomButton
            title={t('startFree')}
            onClick={onClickConnect}
            className="landing__cta-btn"
          />
          {/* <Link className="landing__hero-cta__link" to={ROUTE.MAIN + '#how-it-works'}>
            {t('learn')}
          </Link> */}
        </div>
      </div>

      <div className="landing__hero-notice" role="status" aria-live="polite">
        <p className="landing__hero-notice-title">{t('notice_title')}</p>
        <p className="landing__hero-notice-text">{t('notice_text_1')}</p>
        <p className="landing__hero-notice-text">{t('notice_text_2')}</p>
        <p className="landing__hero-notice-text">{t('notice_text_4')}</p>
        <p className="landing__hero-notice-text">
          <strong>
            {t('notice_contact_before')}{' '}
            <a
              className="landing__hero-notice-link"
              href="https://www.twitch.tv/kosa57/about"
              target="_blank"
              rel="noreferrer"
            >
              {t('notice_contact_link_text')}
            </a>{' '}
            {t('notice_contact_after')}
          </strong>
        </p>
        <p className="landing__hero-notice-text landing__hero-notice-text--muted">
          {t('notice_text_3')}
        </p>
        <p className="landing__hero-notice-text landing__hero-notice-text--muted">
          {t('notice_text_5')}
        </p>
        <p className="landing__hero-notice-text landing__hero-notice-text--muted">
          {t('notice_text_6')}
        </p>
      </div>
    </section>
  );
};
